import { PlacesListResponse } from '@bitecritic-api/src/places/dto/places.dto';
import { GooglePlace } from '@bitecritic-api/src/places/places.controller';
import { PlaceDetailResponse } from '@bitecritic-api/src/places/dto/place.dto';
import requestService from '~/services/requestsService';
import { Period } from '~/constants/period.constants';

const BASE_PLACES = '/places';

const autocomplete = (
  input: string,
  language?: string,
  countryCode?: string,
) => {
  let url = `${BASE_PLACES}/autocomplete?input=${encodeURIComponent(input)}`;

  if (language) {
    url += `&language=${language}`;
  }

  if (countryCode) {
    url += `&countryCode=${countryCode}`;
  }

  return requestService.fetch<GooglePlace[]>(url);
};

interface GetNearbyPlacesParams {
  latitude?: number;
  longitude?: number;
  googlePlaceId?: string;
  radiusInKm?: number;
  page?: number;
  limit?: number;
  period?: Period;
  sort?: string;
  username?: string;
}

export const getNearbyPlaces = async (
  params: GetNearbyPlacesParams,
): Promise<PlacesListResponse | null> => {
  if ((!params.latitude || !params.longitude) && !params.googlePlaceId && !params.username) {
    return null;
  }

  const queryParams = new URLSearchParams({
    page: params.page?.toString() || '1',
    limit: params.limit?.toString() || '50',
    ...(params.period && { period: params.period }),
    ...(params.sort && { sort: params.sort }),
    ...(params.radiusInKm && { radius: params.radiusInKm.toString() }),
    ...(params.username && { username: params.username }),
  });

  if (params.googlePlaceId) {
    queryParams.set('googlePlaceId', params.googlePlaceId);
  } else if (params.latitude && params.longitude) {
    queryParams.set('latitude', params.latitude.toString());
    queryParams.set('longitude', params.longitude.toString());
  }

  const response = await requestService.fetch<PlacesListResponse>(
    `${BASE_PLACES}/nearby?${queryParams.toString()}`,
  );
  return response;
};

export const getPlaceById = async (
  id: string,
  language: string,
): Promise<PlaceDetailResponse> => {
  const response = await requestService.fetch<PlaceDetailResponse>(
    `${BASE_PLACES}/${id}`,
    {
      params: {
        language,
      },
    },
  );

  if (!response) {
    throw new Error('Place not found');
  }

  return response;
};

const placesService = {
  autocomplete,
  getNearbyPlaces,
  getPlaceById,
};

export default placesService;
